import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonDeleteButton, CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions'
import { CurrencySymbol } from '../../../Utility/Constants'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PrintIcon from '@mui/icons-material/Print';

const vendor_category = ['Consumable', 'Non Consumable']

export default function StoreVendorMapping() {
    const history = useHistory();
    const location = useLocation();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [filterdepartmentName, setFilterdepartmentName] = useState('');
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [EditID, setEditID] = useState(null);
    const [EditListID, setEditListID] = useState(null);
    const [DeleteIds, setDeleteIds] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [vendorList, setvendorList] = useState([]);
    const [vendorName, setVendorName] = useState(null);
    const [categoryList, setcategoryList] = useState([]);
    const [categoryName, setcategoryName] = useState(null);
    const [subCategoryList, setsubCategoryList] = useState([]);
    const [VendorMapList, setVendorMapList] = useState([]);
    const [subCategoryName, setsubCategoryName] = useState(null);

    useEffect(() => {
        getSubCategoryList()
        getCategoryList()
        getVendorList()
        getVendorMappingList()
    }, [])


    const getCategoryList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_CATEGORY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setcategoryList(response.data.data?.filter((item) => item?.is_active) || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getVendorList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_VENDOR)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setvendorList(response.data.data?.filter((item) => item?.is_active) || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getVendorMappingList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_VENDOR_MAPPING)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setVendorMapList(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getSubCategoryList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_SUB_CATEGORY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const filData = response.data.data
                        setsubCategoryList(response.data.data?.filter((item) => item?.is_active) || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'vendorName':
                setVendorName(val);
                break
            case 'categoryName':
                setcategoryName(val);
                break
            case 'subCategoryName':
                setsubCategoryName(val);
                break

        }
    }

    const autoComplete = (label, name, val, list, width, disable = false) => {
        return (
            <Box>
                <Autocomplete
                    size={'small'}
                    options={list}
                    name={name}
                    disabled={disable}
                    getOptionLabel={(option) => name === 'vendorName' ? `${option.vendor_name}` : name === 'categoryName' ? `${option.category_name}` : name === 'subCategoryName' ? `${option.sub_category_name}` : option}
                    value={val}
                    onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                    renderInput={(params) => <TextField {...params} disabled={disable} label={label} sx={{ width: width, marginRight: '0.3vw' }} />}
                />
            </Box>
        )
    }

    const TableHeaderBtns = () => {
        return (
            <Box>
            </Box>
        )
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText fromStore={true} isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} renderComponent={TableHeaderBtns} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = VendorMapList.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        VendorMapList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'vendor_name', headerName: 'Vendor Name', flex: 0.4,
                renderCell: (params) => (params.row.vendor_name ? params.row.vendor_name?.length > 40 ?
                    <Tooltip placement="top" title={params.row.vendor_name}><Typography fontSize={'0.9vw'}>{params.row.vendor_name?.slice(0, 40) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.vendor_name}</Typography> : '-')

            },
            {
                field: 'category_name', headerName: 'Category Name', flex: 0.4,
                renderCell: (params) => (params.row.category_name ? params.row.category_name?.length > 40 ?
                    <Tooltip placement="top" title={params.row.category_name}><Typography fontSize={'0.9vw'}>{params.row.category_name?.slice(0, 40) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.category_name}</Typography> : '-')

            },
            {
                field: 'sub_category_name', headerName: 'Sub Category Name', flex: 0.4,
                renderCell: (params) => (params.row.sub_category_name ? params.row.sub_category_name?.length > 40 ?
                    <Tooltip placement="top" title={params.row.sub_category_name}><Typography fontSize={'0.9vw'}>{params.row.sub_category_name?.slice(0, 40) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.sub_category_name}</Typography> : '-')

            },
            // {
            //     field: 'is_active', headerName: 'Status', flex: 0.1,
            //     renderCell: (params) => (<Box component={'div'}>{params?.row?.is_active ? "Active" : 'InActive'}</Box>)
            // },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw"
                                disable={delIDs?.length > 0}
                                onClick={() => {
                                    setVendorName(vendorList?.find((list) => (list?.id === params.row.vendor_id)));
                                    setcategoryName(categoryList?.find((list) => (list?.id === params.row.category_id)));
                                    // setsubCategoryList(subCategoryList?.filter((list) => (list?.category_id === params.row.category_id)));
                                    setsubCategoryName(subCategoryList?.find((list) => (list?.id === params.row.sub_category_id)))
                                    setIsActive(params.row.is_active)
                                    setEditID(params.row.id)
                                }} />
                        </Stack>
                    </Stack>)

            },
        ]
        return (
            <Box sx={{ height: '61vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={VendorMapList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    // page={page}
                    // pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    // onPageChange={(newPage) => { setpage(newPage) }}
                    // onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    // rowsPerPageOptions={[10, 20, 30]}
                    // pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const clearFunction = () => {
        setcategoryName(null)
        setsubCategoryName(null)
        setVendorName(null)
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
        setEditID(null)
    }

    const addCategoryendorDetails = () => {
        try {
            if (!vendorName?.id) {
                errorMessage('Please Select Vendor')
            } else if (!categoryName?.id) {
                errorMessage('Please Select Category')
            } else if (!subCategoryName?.id) {
                errorMessage('Please Select Sub Category')
            } else {
                let data = {
                    'vendor_id': vendorName?.id,
                    'category_id': categoryName?.id,
                    'sub_category_id': subCategoryName?.id,
                    'is_active': isActive,
                }
                if (EditID) {
                    data["id"] = EditID
                    RestAPIService.updateWithOutId(data, Serviceurls.STORE_VENDOR_MAPPING)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                successMessage(response.data.message)
                                clearFunction()
                                getVendorMappingList()
                            }
                        }).catch(e => {
                            setisloader(false)
                            if (e?.response?.data?.status === 'fail') {
                                errorMessage(e.response.data.message)
                            } else {
                                errorMessage(e.message)
                            }
                        })
                } else {
                    RestAPIService.create(data, Serviceurls.STORE_VENDOR_MAPPING)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                successMessage(response.data.message)
                                clearFunction()
                                getVendorMappingList()
                            }
                        }).catch(e => {
                            setisloader(false)
                            if (e?.response?.data?.status === 'fail') {
                                errorMessage(e.response.data.message)
                            } else {
                                errorMessage(e.message)
                            }
                        })
                }
            }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const deleteVendor = () => {
        try {
            RestAPIService.delete(`${Serviceurls.STORE_VENDOR_MAPPING}?ids=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getVendorMappingList()
                        closeFilter();
                        clearFunction()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={vendor_category}
                            value={filterdepartmentName}
                            onChange={(event, newValue) => {
                                setFilterdepartmentName(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Vendor Catogory'}
                                />
                            )}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            setFilterdepartmentName("")
                        }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            getVendorMappingList();
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '15.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                        {autoComplete("Vendor *", 'vendorName', vendorName, vendorList, '15vw')}
                        {autoComplete("Category *", 'categoryName', categoryName, categoryList, '15vw')}
                        {autoComplete("Sub Category *", 'subCategoryName', subCategoryName, subCategoryList?.filter((item) => item?.category_id === categoryName?.id), '15vw', !categoryName?.id)}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', visibility: 'hidden' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' disabled={!EditID} />} label={"Active"} />
                    </Box>
                    <Box sx={{ gap: '1vw' }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} onClick={() => { addCategoryendorDetails() }}>Add</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '61vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this mapping ?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter.bind(this)}
                    removeData={deleteVendor.bind(this)}
                />
                : null}
        </Box>
    )
}
